document.querySelectorAll('.wpl-content-preview').forEach((container) => {
	const stepsEl = container.querySelector('.preview-steps');
	if (!stepsEl) return;

	const slides = JSON.parse(stepsEl.dataset.slides);
	const steps = stepsEl.querySelectorAll('.preview-step');

	let currentSlide = 0;
	const labelEl = container.querySelector('.preview-label');
	const titleEl = container.querySelector('.preview-title');
	const descEl = container.querySelector('.preview-desc');
	const imgEl = container.querySelector('.preview-img');
	const prevBtn = container.querySelector('.preview-prev');
	const nextBtn = container.querySelector('.preview-next');

	function updateArrows() {
		if (prevBtn) prevBtn.disabled = currentSlide === 0;
		if (nextBtn) nextBtn.disabled = currentSlide === slides.length - 1;
	}

	function goToSlide(idx) {
		currentSlide = idx;
		const slide = slides[idx];

		steps.forEach((step, i) => {
			step.classList.remove('active', 'passed');
			if (i === idx) step.classList.add('active');
			if (i < idx) step.classList.add('passed');
		});

		labelEl.textContent = slide.label;
		titleEl.textContent = slide.title;
		descEl.textContent = slide.desc;

		imgEl.style.opacity = 0;
		setTimeout(() => {
			imgEl.src = slide.img;
			imgEl.alt = slide.alt;
			imgEl.style.opacity = 1;
		}, 200);

		updateArrows();
	}

	steps.forEach((step) => {
		step.addEventListener('click', () =>
			goToSlide(Number(step.dataset.slide))
		);
	});

	if (prevBtn)
		prevBtn.addEventListener('click', () =>
			goToSlide(Math.max(0, currentSlide - 1))
		);
	if (nextBtn)
		nextBtn.addEventListener('click', () =>
			goToSlide(Math.min(slides.length - 1, currentSlide + 1))
		);

	updateArrows();
});
